<template>
  <span class="ml-2">
    <v-dialog v-model="dialog"  @keydown.esc="closeDialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="primary" icon dark v-bind="attrs" v-on="on" >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon dark @click="closeDialog" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Izmena kompanije
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-title class="d-flex justify-space-between align-center">
          <span>Promena delatnosti</span>

          <v-btn
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="selectedIndustry"
            :items="industries"
            item-text="name"
            item-value="id"
            return-object
            label="Izaberite delatnost"
            outlined
            dense
            :loading="loadingIndustries"
            class="mb-4"
          />

          <v-divider class="my-4" />

          <div class="text-subtitle-1 mb-2">
            Dodaj novu delatnost
          </div>

          <v-row>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="newIndustryName"
                label="Naziv nove delatnosti"
                outlined
                dense
                hide-details
                @keyup.enter="createIndustry"
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-btn
                block
                color="primary"
                :loading="saving"
                @click="createIndustry"
              >
                Dodaj
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            text
            @click="closeDialog"
          >
            Otkaži
          </v-btn>

          <v-btn
            color="primary"
            :loading="saving"
            :disabled="!selectedIndustry"
            @click="updateCompanyIndustry"
          >
            Sačuvaj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import * as industriesApi from '../api/industries.js';
import * as companiesApi from '../api/companies.js';

export default {
  name: 'CompanyIndustrySelector',

  props: {
    company: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      dialog: false,

      industries: [],
      selectedIndustry: null,

      loadingIndustries: false,
      saving: false,

      newIndustryName: ''
    };
  },

  methods: {
    loadIndustries() {
      this.loadingIndustries = true;

      industriesApi.getAll(this.$store.getters.token)
        .then(response => response.json())
        .then(data => {
          this.industries = data;

          if (this.company.industry) {
            this.selectedIndustry = data.find(
              industry => industry.id === this.company.industry.id
            );
          }
        })
        .catch(() => {
          console.log('Greška pri učitavanju industrija');
        })
        .finally(() => {
          this.loadingIndustries = false;
        });
    },

    async updateCompanyIndustry() {
      if (!this.selectedIndustry)
        return;

      this.saving = true;

      try {
        await companiesApi.modifyIndustry(
          this.company.id,
          this.selectedIndustry.id,
          this.$store.getters.token
        );

        this.company.industry = this.selectedIndustry;

        this.$emit('updated', this.selectedIndustry);

        this.closeDialog();
      }
      catch (e) {
        console.log('Greška pri promeni industrije');
      }
      finally {
        this.saving = false;
      }
    },

    async createIndustry() {
      if (!this.newIndustryName || !this.newIndustryName.trim())
        return;

      this.saving = true;

      try {
        const industryPayload = {
          name: this.newIndustryName.trim()
        };

        await industriesApi.addIndustry(
          industryPayload,
          this.$store.getters.token
        );

        this.newIndustryName = '';
        this.loadIndustries();
      }
      catch (e) {
        console.log('Greška pri dodavanju industrije');
      }
      finally {
        this.saving = false;
      }
    },

    closeDialog() {
      this.dialog = false;
      this.newIndustryName = '';

      if (this.company.industry) {
        this.selectedIndustry = this.industries.find(
          industry => industry.id === this.company.industry.id
        );
      }
      else {
        this.selectedIndustry = null;
      }
    }
  },

  mounted() {
    this.loadIndustries();
  }
};
</script>
